import { X } from "lucide-react";
import { Button } from "@/components/ui/button";

/**
 * What is currently being filtered on, in words, each one removable.
 *
 * The register carries nine filters across two groups. With them set, the only way to
 * know what you are looking at was to read every control — and the two most consequential
 * ones (a date range, an employee) look identical whether they are set or not until you
 * read the value inside them. A register that is quietly filtered is a register that gets
 * exported and handed to somebody as though it were the whole thing.
 *
 * `pills` is `[{ key, label, value, onRemove }]` — `label` names the dimension and
 * `value` the thing chosen, because "Unit 2" alone does not say it is a unit.
 */
export default function FilterPills({ pills, onClearAll, count, noun = "training" }) {
  if (!pills.length) return null;
  return (
    <div className="flex items-start justify-between gap-4 border-t border-border pt-3"
         data-testid="filter-pills">
      <div className="flex flex-wrap items-center gap-1.5">
        <span className="text-sm text-muted-foreground mr-1">
          {count} {count === 1 ? noun : `${noun}s`} matching
        </span>
        {pills.map((p) => (
          <span key={p.key}
                className="inline-flex items-center gap-1 rounded-full border border-border bg-muted/60 pl-2.5 pr-1 py-0.5 text-xs"
                data-testid={`pill-${p.key}`}>
            <span className="text-muted-foreground">{p.label}:</span>
            <span className="font-medium max-w-[16rem] truncate">{p.value}</span>
            <button type="button" onClick={p.onRemove}
                    aria-label={`Remove the ${p.label} filter`}
                    data-testid={`pill-remove-${p.key}`}
                    className="ml-0.5 p-0.5 rounded-full text-muted-foreground hover:text-foreground hover:bg-background focus:outline-none focus-visible:ring-2 focus-visible:ring-ring">
              <X className="w-3 h-3" />
            </button>
          </span>
        ))}
      </div>
      <Button variant="ghost" size="sm" onClick={onClearAll} data-testid="clear-filters"
              className="shrink-0">
        <X className="w-3.5 h-3.5 mr-1" /> Clear all
      </Button>
    </div>
  );
}
